class SizeGuideTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.selectInitialTab()
  }

  setupListeners () {
    super.setupListeners()

    this.els.tab.elements.forEach((tabEl) => {
      this.listeners.add(tabEl, 'click', this.onTabClick.bind(this))
    })

    this.els.tab.elements.forEach((tabEl) => {
      this.listeners.add(tabEl, 'keydown', this.onTabKeydown.bind(this))
    })
  }

  onTabClick (event) {
    this.selectTab(event.currentTarget)
  }

  onTabKeydown (event) {
    const key = event.key

    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return

    event.preventDefault()

    const visibleTabEls = this.visibleTabEls
    const currentIndex = visibleTabEls.indexOf(event.currentTarget)

    if (currentIndex === -1) return

    let nextIndex = currentIndex

    if (key === 'ArrowLeft') {
      nextIndex = currentIndex - 1

      if (nextIndex < 0) {
        nextIndex = visibleTabEls.length - 1
      }
    }

    if (key === 'ArrowRight') {
      nextIndex = currentIndex + 1

      if (nextIndex > visibleTabEls.length - 1) {
        nextIndex = 0
      }
    }

    if (key === 'Home') {
      nextIndex = 0
    }

    if (key === 'End') {
      nextIndex = visibleTabEls.length - 1
    }

    const nextTabEl = visibleTabEls[nextIndex]

    if (!nextTabEl) return

    this.selectTab(nextTabEl)
    nextTabEl.focus()
  }

  selectInitialTab () {
    const pressedTabEl = this.visibleTabEls.find((tabEl) => {
      return tabEl.getAttribute('aria-pressed') === 'true'
    })

    this.selectTab(pressedTabEl || this.visibleTabEls[0])
  }

  selectTab (selectedTabEl) {
    if (!selectedTabEl) return

    const selectedPanelId = selectedTabEl.getAttribute('aria-controls')

    this.els.tab.elements.forEach((tabEl) => {
      const isActive = tabEl === selectedTabEl

      tabEl.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tabEl.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    this.els.panel.elements.forEach((panelEl) => {
      const isActive = panelEl.id === selectedPanelId

      panelEl.setAttribute('aria-hidden', isActive ? 'false' : 'true')
      panelEl.hidden = !isActive
    })
  }

  get visibleTabEls () {
    return this.els.tab.elements.filter((tabEl) => {
      return !tabEl.hidden
    })
  }
}

if (!customElements.get('size-guide-tabs')) {
  customElements.define('size-guide-tabs', SizeGuideTabs)
}
